export const setPaperlessInSessionStorge = (pathURI) => {
  if (pathURI.includes("/paperless")) {
    setPaperlessFlow();
    if (pathURI.includes("/us")) sessionStorage.setItem("region", "us");
    else if (pathURI.includes("/eu")) sessionStorage.setItem("region", "eu");
    else if (pathURI.includes("/ap")) sessionStorage.setItem("region", "ap");
    else if (pathURI.includes("/ca")) sessionStorage.setItem("region", "ca");
    else console.warn("no valid region for session storage");
  } 
};

export const getRegionfromSessionStorge = () => {
  return sessionStorage.getItem("region");
};

export const setPaperlessFlow = () => {
  sessionStorage.setItem("paperless", "true");
};

export const getPaperlessFlow = () => {
  return sessionStorage.getItem("paperless");
};

export const setPaperlessRedirectionToReporting = () => {
  sessionStorage.setItem("reportingRegistrationRedirect", "true");
};

export const getPaperlessRedirectionToReporting = () => {
  return sessionStorage.getItem("reportingRegistrationRedirect");
};

export const removePaperlessRedirectionToReporting = () => {
  return sessionStorage.removeItem('reportingRegistrationRedirect');
};